import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Users, MapPin, ExternalLink } from "lucide-react";
import { api } from "@/lib/apiClient";
import { Loader, EmptyState } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export default function JoinUs() {
  const nav = useNavigate();
  const [jobs, setJobs] = useState(null);
  useEffect(() => { api.get("/internal-jobs").then((r) => setJobs(r.data)); }, []);
  return (
    <div className="max-w-3xl mx-auto">
      <Button variant="ghost" className="rounded-full mb-4 -ml-2" onClick={() => nav("/")} data-testid="join-back"><ArrowLeft className="w-4 h-4 mr-1.5" /> Home</Button>
      <div className="text-center mb-8">
        <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-teal bg-teal/10 px-3 py-1.5 rounded-full"><Users className="w-3.5 h-3.5" /> We're Hiring</span>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold mt-3">Join Our Team</h1>
        <p className="text-muted-foreground mt-2">Open roles within Coach Reyland VA Academy.</p>
      </div>
      {!jobs ? <Loader /> : jobs.length === 0 ? (
        <EmptyState icon={Users} title="No open roles right now" description="Check back soon — we're always growing." testId="join-empty" />
      ) : (
        <div className="space-y-4">
          {jobs.map((j) => (
            <div key={j.id} className="bg-white border border-border rounded-2xl p-6 shadow-sm" data-testid={`internal-job-${j.id}`}>
              <div className="flex items-start justify-between gap-3 flex-wrap">
                <h3 className="font-heading text-lg font-semibold">{j.title}</h3>
                <div className="flex gap-2">
                  {j.type && <Badge variant="secondary">{j.type}</Badge>}
                  {j.location && <Badge className="bg-teal/10 text-teal"><MapPin className="w-3 h-3 mr-1" />{j.location}</Badge>}
                </div>
              </div>
              {j.description && <p className="text-muted-foreground mt-3 whitespace-pre-wrap">{j.description}</p>}
              {j.apply_url && <a href={j.apply_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-teal font-medium mt-4 hover:underline">Apply <ExternalLink className="w-4 h-4" /></a>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
